import { Component, OnInit, Input, ViewChild} from '@angular/core';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {DefaultService} from '../../../gen/swagger-api/api/default.service';
import {AlertService} from '../../shared/services/alert.service';
import {OPERATIONINFO} from '../../../gen/swagger-api/model/oPERATIONINFO';
import {APIOPERATIONINFO} from '../../../gen/swagger-api/model/aPIOPERATIONINFO';
import { OperationInfoViewComponent } from '../operation-info-view/operation-info-view.component';

@Component({
  selector: 'app-operation-info',
  templateUrl: './operation-info.component.html',
  styleUrls: ['./operation-info.component.css']
})
export class OperationInfoComponent implements OnInit {
  @ViewChild(OperationInfoViewComponent)
  view: OperationInfoViewComponent;

  @Input()
  status: string;
  @Input()
  eid: string;
  @Input()
  recordId: number;

  operationInfo: APIOPERATIONINFO;

  constructor(
      private alertService: AlertService,
      private defaultService: DefaultService
  ) {
  }

  ngOnInit() {
  }

  loadOperationInfo()
  {
    if (this.recordId)
    {
      console.log("Loading by recordID");
      this.defaultService.cardsEidAuditRecordIdGet(this.eid, this.recordId).subscribe(
        operationInfo => {
          this.operationInfo = operationInfo;
          this.view.onLoad(operationInfo);
        },
        error => {
          console.error(error);
          if (error) {
            // API not reachable?
            if (error.status == 0) {
              this.alertService.error(error.statusText + ": Please check connection.");
            }
            else {
              this.alertService.error(error.statusText);
            }
          }
        },
        () => ''
      );
    }
    else
    {
      console.log("Loading last record");
      this.defaultService.cardsEidStatusGet(this.eid).subscribe(
        operationInfo => {
          this.operationInfo = operationInfo;
          this.view.onLoad(operationInfo);
        },
        error => {
          console.error(error);
          if (error) {
            // API not reachable?
            if (error.status == 0) {
              this.alertService.error(error.statusText + ": Please check connection.");
            }
            else {
              this.alertService.error(error.statusText);
            }
          }
        },
        () => ''
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/operation-info/operation-info.component.ts